export const smsConstants = {
  SIDEBAR_CAMPAIGN_INFO__SET: 'SIDEBAR_CAMPAIGN_INFO__SET',
  RESET_SMS_STORE: 'RESET_SMS_STORE',
  FILL_SMS_STORE: 'FILL_SMS_STORE',
  CHANGE_DEFAULT_DATE_STATE: 'CHANGE_DEFAULT_DATE_STATE',
  RESET_SIDEBAR_CAMPAIGN_INFO: 'RESET_SIDEBAR_CAMPAIGN_INFO',
  SET_IS_TIMEZONE_LOADED: 'SET_IS_TIMEZONE_LOADED',
};
